"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoTileSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _videoTile = _interopRequireDefault(require("./video-tile"));
const VideoTileSectionContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoTileSectionContainer",
  class: "pl-v1ng494s"
});

/**
 * Video Tile Section component.
 * @module VideoTileSection
 *
 * @param {Object} props React props
 * @param {Array} props.videoTileResults Array of child Video Tiles
 * @returns {React.ReactElement} VideoTileSection component
 * @public
 */
function VideoTileSection({
  videoTileResults
}) {
  return /*#__PURE__*/_react.default.createElement(VideoTileSectionContainer, {
    "data-cy": "video-tile-section"
  }, videoTileResults?.map((videoTileResult, i) => /*#__PURE__*/_react.default.createElement(_videoTile.default, (0, _extends2.default)({
    key: i,
    rank: i
  }, videoTileResult))));
}
VideoTileSection.propTypes = {
  videoTileResults: _propTypes.default.arrayOf(_propTypes.default.shape({
    _name: _propTypes.default.string,
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    url: _propTypes.default.string,
    thumbnailUrl: _propTypes.default.string,
    trackingCustomProps: _propTypes.default.object
  }))
};